module.exports = __webpack_public_path__ + "img/banner-step1.0b1cf0d0.svg";